import React from "react";
import ReactDOM from "react-dom/client"; // Para React 18 y superiores
import App from "./App"; // Importa el componente principal de la app
import "./index.css"; // Si tienes estilos globales

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
